module.exports = __webpack_public_path__ + "img/das_400.5b1cd34a.jpg";